var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    [
      _c("template", { slot: "title" }),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c("div", { staticClass: "well ovy-auto hp-10 tab__container" }, [
          _c(
            "div",
            { staticClass: "tab-header__container flex-row" },
            [
              _c(
                "div",
                {
                  ref: "tab-header__heading",
                  staticClass: "typographies-heading-h3"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.currentPipeline) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.edit"),
                  type: "secondary",
                  size: "small"
                },
                on: { click: _vm.toPipelineParams }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("section", { staticClass: "flex tab-list_container" }, [
            _c(
              "ul",
              { staticClass: "tab-list_items my-0" },
              [
                _c(
                  "p",
                  { staticClass: "gray-80 py-2 fs-2 pl-2 m-0 flex-row" },
                  [
                    _c("span", { staticClass: "pr-3" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("PROBABILITÉ")))
                    ]),
                    _vm._v(
                      _vm._s(_vm.$l10n.__("ÉTAPE")) + "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.steps, function(step) {
                  return _c(
                    "li",
                    {
                      key: step.id,
                      staticClass: "tab-list__item--wrapper flex-column",
                      class: _vm.stepClasses(step.id),
                      on: {
                        mouseover: function($event) {
                          return _vm.stepIsHovered(step.id)
                        },
                        mouseleave: function($event) {
                          return _vm.stepIsHovered(null)
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "tab-list--separator ml-3",
                        class: _vm.isActiveSeparator(step.id)
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-row tab-list_item" },
                        [
                          _c("div", { staticClass: "flex-row" }, [
                            _c(
                              "span",
                              { staticClass: "lh-20 mr-3 tab-list_item--left" },
                              [_vm._v(_vm._s(step.probability) + "%")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "lh-20" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(step.name) +
                                  "\n                                "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isStepHovered(step.id)
                            ? _c("CompassButton", {
                                staticClass: "tab-list_item--action",
                                attrs: {
                                  label: _vm.$t.__(
                                    "overview.tabs.TabPipeline.skip_step"
                                  ),
                                  type: "tertiary",
                                  size: "small",
                                  loading: _vm.isLoaded
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.updateOpportunityStep(step)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                })
              ],
              2
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }